import type { RouteLocationRaw, Router, RouteRecordName } from 'vue-router'

import listRouteMap from '@/constants/listRouteMap.ts'

const stripTrailingSlash = (path: string): string => (path.endsWith('/') ? path.slice(0, -1) : path)

const findDetailRouteName = (router: Router, doctype: string): null | RouteRecordName => {
  const homeRouteName = listRouteMap[doctype]
  if (!homeRouteName) return null

  const allRoutes = router.getRoutes()
  const homeRoute = allRoutes.find((route) => route.name === homeRouteName)
  if (!homeRoute) return null

  const base = stripTrailingSlash(homeRoute.path)
  const detailPath = `${base}/:id`

  const detailRoute = allRoutes.find(
    (route) => stripTrailingSlash(route.path) === stripTrailingSlash(detailPath),
  )

  return detailRoute?.name ?? null
}

const resolveDoctypeDetailRoute = (
  router: Router,
  doctype: string,
  id: string,
): null | RouteLocationRaw => {
  const detailName = findDetailRouteName(router, doctype)
  if (detailName) {
    return { name: detailName, params: { id } }
  }

  // fallback: try path directly
  const homeRouteName = listRouteMap[doctype]
  if (!homeRouteName) return null
  const homeRoute = router.getRoutes().find((route) => route.name === homeRouteName)
  if (!homeRoute) return null

  const base = stripTrailingSlash(homeRoute.path)
  const concretePath = `${base}/${encodeURIComponent(id)}`
  const resolved = router.resolve(concretePath)
  if (resolved.matched.length > 0) {
    return { path: concretePath }
  }

  return null
}

export { findDetailRouteName, resolveDoctypeDetailRoute }
